import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { PaymentPurposesComponent } from './payment-purposes.component'
import { CreatePaymentPurposeComponent } from './create-payment-purpose/create-payment-purpose.component'
import { UpdatePaymentPurposeComponent } from './update-payment-purpose/update-payment-purpose.component'
import { paymentPurposesRoutes } from './payment-purposes.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    PaymentPurposesComponent,
    CreatePaymentPurposeComponent,
    UpdatePaymentPurposeComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(paymentPurposesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    PaymentPurposesComponent,
    CreatePaymentPurposeComponent,
    UpdatePaymentPurposeComponent,
  ],
})
export class PaymentPurposesModule {}
